const initialState = {
  modalDetailPengajuan: true,
  pengajuanLama: true,
  modalDetailInsentive: true,
  modalDetailInsentiveSpv: true,
  modalDetailInsentiveAM: true,
  listPengajuan: [],
  disetujui: [],
  Diproses: [],
  diajukan: [],
  ditolak: [],
  gagalTerkirim: [],
  listPengajuanBestada: [],
  listPengajuanById: [],
  listPencairan: [],
  listStatus: [],
  listTotalTargetUser: [],
  detailPengajuan: [],
  detailInsentive: [],
  totalPencairan: [],
  pencairanALLData: [],
  pencairanALLDataSpv: [],
  pencairanALLDataAM: [],
  limitPagePencairanAll: [],
  limitPagePencairanAllSpv: [],
  limitPagePencairanAllAM: [],
  valueCol: "12",
  valueColPrev: "0",
  urlPreview: "",
  titlePreview: "",
  urlDokumen: "",
};

const pengajuanKoorReducer = (state = initialState, action) => {
  // console.log(initialState, "INITIAL STATE");
  let { type, data } = action;
  switch (type) {
    case "SET_STEP_PENGAJUAN":
      return {
        ...state,
        modalDetailPengajuan: data,
      };
    case "SET_PENGAJUAN_LAMA":
      return {
        ...state,
        pengajuanLama: data,
      };
    case "SET_ALL_STATUS":
      return {
        ...state,
        listStatus: data,
      };
    case "SET_ALL_TOTAL_USER":
      return {
        ...state,
        listTotalTargetUser: data,
      };
    case "SET_ALL_PENGAJUAN":
      return {
        ...state,
        listPengajuan: data,
      };
    case "SET_AMBIL_DITOLAK":
      return {
        ...state,
        ditolak: data,
      };
    case "SET_AMBIL_DISETUJUI":
      return {
        ...state,
        disetujui: data,
      };
    case "SET_AMBIL_DIAJUKAN":
      return {
        ...state,
        diajukan: data,
      };
    case "SET_AMBIL_DIPROSES":
      return {
        ...state,
        Diproses: data,
      };
    case "SET_AMBIL_GAGALTERKIRIM":
      return {
        ...state,
        gagalTerkirim: data,
      };
    case "SET_ALL_PENGAJUAN_BESTADA":
      return {
        ...state,
        listPengajuanBestada: data,
      };
    case "SET_ALL_PENGAJUAN_BY_ID":
      return {
        ...state,
        listPengajuanById: data,
      };
    case "SET_ALL_PENGAJUAN_BESTADA_BY_ID":
      return {
        ...state,
        listPengajuanById: data,
      };
    case "SET_ALL_PENCAIRAN":
      return {
        ...state,
        listPencairan: data,
      };
    case "SET_ALL_TOTAL_PENCAIRAN":
      return {
        ...state,
        totalPencairan: data,
      };
    case "SET_DETAIL_PENGAJUAN":
      return {
        ...state,
        detailPengajuan: data,
      };
    case "SET_PENCAIRAN_ALL":
      return {
        ...state,
        pencairanALLData: data,
      };
    case "SET_LIMIT_PAGE":
      return {
        ...state,
        limitPagePencairanAll: data,
      };
    case "SET_PENCAIRAN_ALL_SPV":
      return {
        ...state,
        pencairanALLDataSpv: data,
      };
    case "SET_LIMIT_PAGE_SPV":
      return {
        ...state,
        limitPagePencairanAllSpv: data,
      };
    case "SET_PENCAIRAN_ALL_AM":
      return {
        ...state,
        pencairanALLDataAM: data,
      };
    case "SET_LIMIT_PAGE_AM":
      return {
        ...state,
        limitPagePencairanAllAM: data,
      };
    case "SET_DETAIL_PENGAJUAN_BESTADA":
      return {
        ...state,
        detailPengajuan: data,
      };
    case "SET_DETAIL_INSENTIVE":
      return {
        ...state,
        modalDetailInsentive: data,
      };
    case "SET_DETAIL_INSENTIVE_SPV":
      return {
        ...state,
        modalDetailInsentiveSpv: data,
      };
    case "SET_DETAIL_INSENTIVE_AM":
      return {
        ...state,
        modalDetailInsentiveAM: data,
      };
    case "SET_DATA_DETAIL_INSENTIVE":
      return {
        ...state,
        detailInsentive: data,
      };
    case "PREVIEW_DOKUMEN":
      return {
        ...state,
        valueCol: "6",
        valueColPrev: "6",
        urlPreview: data,
        titlePreview: data,
      };
    case "HIDE_DOKUMEN":
      return {
        ...state,
        valueCol: "12",
        valueColPrev: "0",
        urlPreview: "",
        titlePreview: "",
      };
    case "SHOW_URL_DOKUMEN":
      return {
        ...state,
        urlDokumen: data,
      };
    default:
      return state;
  }
};
export default pengajuanKoorReducer;
